const React = require('react');
const { useContext } = React;
const Avatar = require('components/ProfileAvatar');
const { LeaderContext } = require('./WeeklyLeaders');

module.exports = React.forwardRef(function WeeklyAvatar({ userId, style, sx, ...props }, ref) {

    const ranks = useContext(LeaderContext);
    const metal = { 1: 'Gold', 2: 'Silver', 3: 'Bronze' }[ranks[userId]];
    const color = { Gold: '#e9b92f', Silver: '#b2c3d5', Bronze: '#cf935d' }[metal];
    return <Avatar {...props} ref={ref} data-leader-frame={metal} style={metal ? { ...style, boxSizing: 'border-box', border: `3px solid ${color}`, boxShadow: `0 0 0 1px ${color}` } : style} sx={sx} />;
});
